/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Display.Canvas
 */

module.exports = {

    Interpolation: require('./CanvasInterpolation'),
    Pool: require('./CanvasPool'),
    Smoothing: require('./Smoothing'),
    TouchAction: require('./TouchAction'),
    UserSelect: require('./UserSelect')
    
};



//////////////////
// WEBPACK FOOTER
// ./display/canvas/index.js
// module id = 507
// module chunks = 0